import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 31041 63789"
    {...props}
  >
    <defs>
      <style>
        {".str0{stroke:#2b2a29;stroke-width:701.482}.fil0{fill:#2b2a29}"}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970280779376">
        <path
          d="M30690 12804v18116L15521 18569 351 30920V12804L15521 452z"
          className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}
        />
        <path
          d="M30690 35823v5914L15521 29384 351 41737v-5914l15170-12352z"
                    className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}

        />
        <path
          d="M30690 46514v5914L15521 40075 351 52428v-5914l15170-12352z"
                    className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}

        />
        <path
          d="M30690 57139v5912L15521 50699 351 63051v-5912l15170-12353z"
                    className="fill stroke1"
          style={{
            strokeWidth: 701.482,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
